(function () {
  'use strict';

  function getMobileMenuParts(toggle) {
    var header = toggle.closest('[data-lux-site-header], .lux-site-header, .hero-topbar');
    if (!header) return null;
    var menu = header.querySelector('[data-hero-mobile-menu]');
    if (!menu) return null;
    return { header: header, menu: menu, toggle: toggle };
  }

  function setMobileMenuOpen(parts, open) {
    parts.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    parts.toggle.classList.toggle('is-open', open);
    if (open) {
      parts.menu.removeAttribute('hidden');
      parts.menu.classList.add('is-open');
      document.body.classList.add('hero-menu-open');
      document.dispatchEvent(new CustomEvent('lux:close-mega'));
    } else {
      parts.menu.setAttribute('hidden', '');
      parts.menu.classList.remove('is-open');
      document.body.classList.remove('hero-menu-open');
    }
  }

  function toggleMobileMenu(toggle) {
    var parts = getMobileMenuParts(toggle);
    if (!parts) return;
    var open = parts.toggle.getAttribute('aria-expanded') === 'true';
    setMobileMenuOpen(parts, !open);
  }

  function closeAllMobileMenus() {
    document.querySelectorAll('[data-hero-menu-toggle][aria-expanded="true"]').forEach(function (toggle) {
      var parts = getMobileMenuParts(toggle);
      if (parts) setMobileMenuOpen(parts, false);
    });
  }

  /* Hamburger + mobile drawer — delegated so it works on all pages/devices */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hero-menu-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileMenu(toggle);
      return;
    }

    if (e.target.closest('[data-hero-mobile-menu] a')) {
      closeAllMobileMenus();
      return;
    }

    if (!e.target.closest('[data-hero-mobile-menu]') && !e.target.closest('[data-hero-menu-toggle]')) {
      closeAllMobileMenus();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllMobileMenus();
  });

  /* Bind link close handlers for menus rendered before delegation (legacy) */
  document.querySelectorAll('[data-hero-mobile-menu]').forEach(function (menu) {
    menu.querySelectorAll('a').forEach(function (link) {
      if (link.dataset.luxMenuLinkBound) return;
      link.dataset.luxMenuLinkBound = '1';
      link.addEventListener('click', closeAllMobileMenus);
    });
  });

  /* Mobile mega menu accordions (submenus) */
  document.addEventListener('click', function (e) {
    var megaToggle = e.target.closest('[data-lux-mega-mobile-toggle]');
    if (!megaToggle) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = megaToggle.getAttribute('data-lux-mega-mobile-toggle');
    var group = megaToggle.closest('.lux-mega-mobile-group');
    if (!group) return;
    var panel = group.querySelector('[data-lux-mega-mobile-panel="' + handle + '"]');
    if (!panel) return;
    var opening = megaToggle.getAttribute('aria-expanded') !== 'true';

    document.querySelectorAll('[data-lux-mega-mobile-toggle][aria-expanded="true"]').forEach(function (other) {
      if (other === megaToggle) return;
      other.setAttribute('aria-expanded', 'false');
      var otherHandle = other.getAttribute('data-lux-mega-mobile-toggle');
      var otherGroup = other.closest('.lux-mega-mobile-group');
      var otherPanel = otherGroup && otherGroup.querySelector('[data-lux-mega-mobile-panel="' + otherHandle + '"]');
      if (otherPanel) {
        otherPanel.hidden = true;
        otherPanel.setAttribute('hidden', '');
      }
    });

    megaToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    panel.hidden = !opening;
    if (opening) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
  });

  /* Scroll shadow — global solid header + homepage hero menu */
  document.querySelectorAll('[data-lux-site-header], .template-index .hero > .hero-topbar').forEach(function (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  function luxHeaderSearchRoot(node) {
    return node.closest('header') || node.closest('.hero-topbar');
  }

  function closeLuxHeaderSearch(header) {
    if (!header) return;
    var panel = header.querySelector('[data-lux-header-search-bar]');
    var toggle = header.querySelector('[data-lux-header-search-toggle]');
    if (!panel) return;
    panel.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-open');
    }
    document.body.classList.remove('lux-search-open');
  }

  function openLuxHeaderSearch(header) {
    if (!header) return;
    var panel = header.querySelector('[data-lux-header-search-bar]');
    var toggle = header.querySelector('[data-lux-header-search-toggle]');
    var input = header.querySelector('[data-lux-header-search-input]');
    var mobileMenu = header.querySelector('[data-hero-mobile-menu]');
    var menuToggle = header.querySelector('[data-hero-menu-toggle]');
    if (!panel) return;

    if (mobileMenu && !mobileMenu.hidden) {
      mobileMenu.hidden = true;
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.classList.remove('is-open');
      }
      document.body.classList.remove('hero-menu-open');
    }

    document.querySelectorAll('[data-lux-header-search-bar]:not([hidden])').forEach(function (openPanel) {
      if (openPanel !== panel) closeLuxHeaderSearch(luxHeaderSearchRoot(openPanel));
    });

    panel.hidden = false;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
    }
    document.body.classList.add('lux-search-open');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  document.querySelectorAll('[data-lux-header-search-toggle]').forEach(function (toggle) {
    var header = luxHeaderSearchRoot(toggle);
    if (!header || toggle.dataset.luxSearchBound) return;
    toggle.dataset.luxSearchBound = '1';

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeLuxHeaderSearch(header);
      else openLuxHeaderSearch(header);
    });

    var closeBtn = header.querySelector('[data-lux-header-search-close]');
    if (closeBtn && !closeBtn.dataset.luxSearchBound) {
      closeBtn.dataset.luxSearchBound = '1';
      closeBtn.addEventListener('click', function () {
        closeLuxHeaderSearch(header);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-lux-header-search-bar]:not([hidden])').forEach(function (panel) {
      closeLuxHeaderSearch(luxHeaderSearchRoot(panel));
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-lux-header-search-bar]:not([hidden])').forEach(function (panel) {
      var header = luxHeaderSearchRoot(panel);
      if (!header || header.contains(event.target)) return;
      closeLuxHeaderSearch(header);
    });
  });

  /* Legacy theme header scroll */
  var legacyHeader = document.querySelector('header.header.luxlaria-header');
  if (legacyHeader) {
    var onLegacyScroll = function () {
      legacyHeader.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onLegacyScroll, { passive: true });
    onLegacyScroll();
  }
})();
